<select class="mvd_form-control" (change)="handleAssignmentDropdownOperation(businessTransaction, $event.target.value)"
    [disabled]="showDisabled"
    (focus)="onFocus()" (focusout)="onFocusOut()">
    <option value="{{businessTransaction.assignedUserLoginId}}" [selected]="true">
        {{businessTransaction.assignedUserLoginName}}
    </option>
    <ng-container *ngIf="hasFocus">
        <option value="{{userLogin.id}}" *ngFor="let userLogin of dropdownList">
            {{userLogin.firstName}} {{userLogin.lastName}}
        </option>
    </ng-container>
</select>
